import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AuthUnit} from "../x-models/auth-unit";
import {Tuple} from "../../../models/_generic/tuple";
import {ServerEndpoints} from "../../../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class SettingHttpService {

  constructor(private httpClient: HttpClient, @Inject("BASE_URL") private baseUrl: string) {
  }

  /*
   * REMOVED: `SetAuth` / `SetAuths` / `SumUpIsConfigured` / `TelegramIsConfigured`.
   *
   * All four existed for the two panels on `SettingsComponent` that no user could reach — Kartenzahlungen was
   * rendered under `*ngIf="false"` and Telegram had no markup at all — and `SettingsComponent` was their only
   * caller in the SPA. They went with the panels.
   *
   * The four SERVER endpoints they addressed (`/Company/Setting/SetAuthPair`, `.../SetAuthPairs`,
   * `.../SumUpIsConfigured`, `.../TelegramIsConfigured`) are deliberately UNTOUCHED, and so are their entries
   * in `server.endpoints.ts` and `permission.service.ts`: both of those files are GENERATED from the server's
   * own surface (`Management/Permission/GenerateTsEndpoints` and `.../GenerateTsPermissionSets`) and describe
   * what the API offers, not what the SPA happens to call — 42 of the 292 entries already have no caller.
   * Hand-editing them would put the mirror out of step with the thing it mirrors.
   *
   * If a SumUp panel is ever built for real, re-add the wrapper here; nothing on the server has to change.
   */

  SetTimezone(timezone: string): Observable<AuthUnit> {
    return this.httpClient.put<AuthUnit>(this.baseUrl + ServerEndpoints.Administration_Settings_SetTimezone + "?timezone=" + timezone, {})
  }

  GetTimezone(): Observable<AuthUnit> {
    return this.httpClient.get<AuthUnit>(this.baseUrl + ServerEndpoints.Administration_Settings_GetTimezone)
  }

  SetLogo(url: string | null = null): Observable<Tuple<string | undefined, any>> {
    return this.httpClient.put<Tuple<string | undefined, any>>(this.baseUrl + ServerEndpoints.Administration_Settings_SetLogo + "?url=" + (!url ? "" : url), {});
  }

  GetLogo(): Observable<Tuple<string | undefined, any>> {
    return this.httpClient.get<Tuple<string | undefined, any>>(this.baseUrl + ServerEndpoints.Administration_Settings_GetLogo);
  }
}
